import { VehiclesController } from "../vehicles_controller"

export default class extends VehiclesController {
  static targets = ["delete_link"]

  destroyVehicle(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this._deleteVehicle(url);
  }

  //
  // Private
  //
  _deleteVehicle(url) {
    let confirmMessage = this.data.get("confirm-text");
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'delete',
        success: (data) => {
          if (data) {
            super._successNotify(data.notification_title, data.notification_message);
            this._removeRowFromTable(data.table_type, data);
          }
        },
        error: (data) => {
          if (data) {
            super._errorNotify(data.notification_title, data.notification_message);
          }
        }
      })
    }
  }

  _removeRowFromTable(table_type, data) {
    switch (table_type) {
      case "sidebar":
        Turbolinks.visit(data.url);
        break;
      case "in_operation":
        super._deleteTabulatorRowById(this._inOperationTabulator, data.id);
        break;
      case "out_of_operation":
        super._deleteTabulatorRowById(this._outOfOperationTabulator, data.id);
        break;
    }
  }
}